
export const GET_OFFICERS = 'GET_OFFICERS';
export const EDIT_OFFICER = 'EDIT_OFFICER';
export const NEW_OFFICER = 'NEW_OFFICER';
export const DELETE_OFFICER = 'DELETE_OFFICER';

export function getOfficers(supervisors, error=null) {
    return {
        type: GET_OFFICERS,
        supervisors,
        error
    }
}

export function editOfficer (supervisor, error=null) {
    return {
        type: EDIT_OFFICER,
        supervisor,
        error
    }
}

export function addOfficer (supervisor, error=null) {
    return {
        type: NEW_OFFICER,
        supervisor,
        error
    }
}

// Delete Supervisor
export function deleteOfficer (id, error=null) {
    return {
        type: DELETE_OFFICER,
        id,
        error
    }
}
